export default "__VITE_ASSET__CCBRk$mD__"